import { useState, useEffect } from "react";

function useCurrentVoucherCampaign(
  loadForSpecificTreatmentCategoryAndPurchaseMode,
  treatmentCategory,
  purchaseMode
) {
  const [currentVoucherCampaign, setCurrentVoucherCampaign] = useState({});
  const [loading, setLoading] = useState(true);

  const loadCurrentVoucherCampaign = () => {
    setLoading(true);
    $.getJSON("/voucher_campaigns/current").then((campaign) => {
      if (campaign && campaign.voucher_campaign_items) {
        const data = { show_disabled: true };

        if (treatmentCategory) {
          data.treatment_category = treatmentCategory;
        }

        if (purchaseMode) {
          data.purchase_mode = purchaseMode;
        }

        $.getJSON("/products", data).then((products) => {
          // filter out items that do not have an associated product
          campaign.voucher_campaign_items =
            campaign.voucher_campaign_items.filter((item) => {
              item.product = products.find(
                (product) =>
                  product.square_item_variation_id ===
                  item.square_item_variation_id
              );
              if (item.product) {
                return item;
              } else {
                return null;
              }
            });

          // sort by price
          campaign.voucher_campaign_items.sort(
            (a, b) => a.product.price - b.product.price
          );

          // set the current voucher campaign to the filtered and sorted campaign
          setCurrentVoucherCampaign(campaign);
          setLoading(false);
        });
      }
    });
  };

  useEffect(() => {
    if (!loadForSpecificTreatmentCategoryAndPurchaseMode) {
      loadCurrentVoucherCampaign();
    }
  }, []);

  useEffect(() => {
    if (
      loadForSpecificTreatmentCategoryAndPurchaseMode &&
      treatmentCategory &&
      purchaseMode
    ) {
      loadCurrentVoucherCampaign();
    }
  }, [treatmentCategory, purchaseMode]);

  return { currentVoucherCampaign, loading };
}

export default useCurrentVoucherCampaign;
